module.exports = __webpack_public_path__ + "static/media/devices.fb6a7382.png";